<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000929') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1002139') }}</span>
            <span class="basic_txt">{{ detailsData.ymsCarrierHandoverOrderNumber }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1001522') }}</span>
            <span class="basic_txt">{{ detailsData.statusTxt }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1001180') }}</span>
            <span class="basic_txt">{{ detailsData.createdTime }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004132') }}</span>
            <span class="basic_txt">{{ detailsData.handoverTime }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--明细信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004100') }}</h2>
        </template>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="650"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="tableData">
          </Table>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllUsersInfo, getAllYmsWarehouseData, getUserNameByUserId, getWarehouseName} from "@/utils/common";

export default {
  name: 'handoverSheetManageDetails',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 6,
      detailsData: {},
      tableColumns: [
        {
          title: 'NO',
          key: 'index',
          align: 'center',
          width: 100,
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'),
          key: 'packageCode',
          align: 'center',
          render(h, params) {
            let packageCode = params.row.packageCode;
            let status = params.row.ymsPackageInfo.status || null;
            let text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004126');
            return h('div', {class: 'flex justify-content-center align-items-center'}, [
              h('span', packageCode),
              status === 8 ? h('span', {class: 'crimsonRedColor ml6'}, text) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004127'),
          key: 'userWeight',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004128'),
          key: 'ymsWarehouseName',
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004129'),
          key: 'createdBy',
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 130,
          render: (h, params) => {
            let status = params.row.ymsPackageInfo.status || null;
            let ymsCarrierHandoverOrderDetailId = params.row.ymsCarrierHandoverOrderDetailId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000402'),
                    color: '#FF0000',
                    show: status === 8,
                    clickFn: () => {
                      v.removePackageBtn(ymsCarrierHandoverOrderDetailId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      warehouseList: [],
      userInfoList:{}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await getAllYmsWarehouseData().then((data) => {
          this.warehouseList = data;
        });
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await this.getDetailsData();
      })();
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/handoverSheetManage');
    },
    // 获取列表数据
    getDetailsData() {
      let v = this;
      if (v.getPermission('ymsCarrierHandoverOrder_detail')) {
        let ymsCarrierHandoverOrderId = v.$route.query.ymsCarrierHandoverOrderId;
        v.tableLoading = true;
        v.axios.get(api.get_ymsCarrierHandoverOrder + `${ymsCarrierHandoverOrderId}`).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            let data = response.data.datas;
            let statusList = [
              {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004130')},
              {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003693')}
            ];
            statusList.map((item) => {
              if (item.value === data.status) {
                data.statusTxt = item.title;
              }
            });
            data.createdTime = data.createdTime ? v.$uDate.dealTime(data.createdTime, 'fulltime') : '';
            data.handoverTime = data.handoverTime ? v.$uDate.dealTime(data.handoverTime, 'fulltime') : '';
            v.detailsData = data;
            v.tableData = data.ymsCarrierHandoverOrderDetails;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 移除
    removePackageBtn(ymsCarrierHandoverOrderDetailId) {
      let v = this;
      let query = {
        ymsCarrierHandoverOrderDetailIds: [ymsCarrierHandoverOrderDetailId],
        ymsCarrierHandoverOrderId: v.$route.query.ymsCarrierHandoverOrderId
      };
      v.axios.post(api.post_ymsCarrierHandoverOrder_removePackage, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004131'));
          v.getDetailsData();
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
